import React from "react";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";

const CtaBanner = ({ onBook }) => {
  const { lang } = useLanguage();
  const t = content[lang].ctaBanner;

  return (
    <section className="relative py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="relative overflow-hidden rounded-3xl border border-narwhal-teal/30 bg-gradient-to-br from-narwhal-teal/[0.12] via-narwhal-panel/60 to-narwhal-dark p-9 md:p-14">
          <div className="absolute inset-0 hero-grid-bg opacity-40" />
          <div className="relative flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-light text-white leading-tight">
                {t.title} <span className="block text-narwhal-teal font-medium">{t.titleAccent}</span>
              </h2>
              <p className="mt-4 text-sm text-narwhal-muted">{t.note}</p>
            </div>
            <button onClick={onBook} data-testid="cta-banner-book-call-button" className="group shrink-0 inline-flex items-center gap-2 rounded-md bg-narwhal-teal px-7 py-4 text-narwhal-dark font-semibold hover:bg-white transition-colors">
              {t.cta}<ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
